var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpY(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.519231 4.15385C0.519231 2.14651 2.1465 0.519231 4.15385 0.519231H29.0765C31.0838 0.519231 32.7111 2.1465 32.7111 4.15385V19.7304C32.7111 21.7378 31.0838 23.3651 29.0765 23.3651H4.15385C2.1465 23.3651 0.519231 21.7378 0.519231 19.7304V4.15385Z",
    fill: "#675000",
    stroke: "#E1CA00",
    strokeWidth: 1.03846
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9071_7874)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.34375,
    y: 5.19141,
    width: 14.5383,
    height: 14.5383,
    rx: 7.26913,
    fill: "#675000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1914 9.3439H22.4963V7.95822H21.8058V7.26765H21.1107V6.57708H19.7295V5.88197H18.3438V5.19141H14.8819V5.88197H13.4962V6.57708H12.1106V7.26765H11.42V7.95822H10.7294V9.3439H10.0343V10.7296H9.34375V14.1915H10.0343V15.5772H10.7294V16.9583H11.42V17.6534H12.1106V18.344H13.4962V19.0391H14.8819V19.7297H18.3438V19.0391H19.7295V18.344H21.1107V17.6534H21.8058V16.9583H22.4963V15.5772H23.1914V14.1915H23.882V10.7296H23.1914V9.3439ZM18.3438 16.9583H17.6533V17.6534H15.5725V16.9583H14.8819V14.8821H15.5725V14.1915H17.6533V14.8821H18.3438V16.9583ZM20.4201 10.7296H19.7295V11.4201H19.0344V12.1153H18.3438V12.8058H17.6533V13.5009H15.5725V12.1153H16.2676V11.4201H16.9582V10.7296H17.6533V9.3439H16.9582V8.65333H15.5725V9.3439H14.8819V10.7296H12.8057V8.65333H13.4962V7.95822H14.1914V7.26765H14.8819V6.57708H18.3438V7.26765H19.0344V7.95822H19.7295V8.65333H20.4201V10.7296Z",
    fill: "#E1CA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9071_7874"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.34375,
    y: 5.19141,
    width: 14.5383,
    height: 14.5383,
    rx: 7.26913,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpY);
export default __webpack_public_path__ + "static/media/help-y.04b08d81d18ee75fff69b5d16c78cf3b.svg";
export { ForwardRef as ReactComponent };